module.exports = __webpack_public_path__ + "img/drink5.5ef911b4.png";